import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { ShowAlert } from "../../utils/functions";
import { useStores } from "../../stores/root-store";
import { useNavigate, useSearchParams } from "react-router-dom";

const ResetPassword = observer(() => {
  const [searchParams] = useSearchParams();
  const { authStore } = useStores();
  const { resetPassword } = authStore;
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [isFormValid, setIsFormValid] = useState(false);
  const userId = searchParams.get("userId");
  const code = searchParams.get("code");

  useEffect(() => {
    if (!userId || !code) navigate("/");
  }, [userId, code]);

  useEffect(() => {
    setIsFormValid(password && password.length > 5 ? true : false);
  }, [password]);

  const submitCallback = (res: boolean, token: string) => {
    if (res && token) {
      ShowAlert.Info(
        "Password has been reset. You can login using your new password."
      );
      navigate("/");
    } else ShowAlert.Error("Request failed. Please try again.");
  };

  const handleFormSubmit = () => {
    if (!isFormValid) ShowAlert.Error("Please enter valid password.");
    else {
      if (!userId || !code) {
        ShowAlert.Error(
          "Invalid password reset link. Please try forgot password option again."
        );
        return;
      }
      resetPassword(userId, code, password, submitCallback);
    }
  };

  return (
    <div className="container mt-3">
      <div className="row">
        <div className="mx-auto col-sm-12 col-md-6 col-lg-4 shadow-lg p-4">
          <h5 className="text-start">Reset Password</h5>
          <div className="panel panel-default">
            <div className="panel-body">
              <form autoComplete="off">
                <div className="form-floating">
                  <input
                    type="password"
                    className="form-control"
                    id="password"
                    placeholder="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <label htmlFor="password">New Password</label>
                </div>
                <div className="small text-muted text-start">
                  *minimum 6 characters length
                </div>

                <div className="btn-group d-flex mt-3">
                  <button
                    onClick={handleFormSubmit}
                    className="btn btn-default rounded-0 flex-fill"
                    disabled={!isFormValid}
                    type="button"
                  >
                    Reset Password
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default ResetPassword;
